import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { taskRoutes } from 'router/taskRoutes';
import DOMPurify from 'dompurify';
import { settingsRoutes } from 'router/settingsRoutes';
import { recognitionRoutes } from 'router/recognitionRoutes';
import { taskManagementRoutes } from 'router/taskManagementRoutes';

export const useDocTitle = () => {
  const location = useLocation();
  const defaultTitle = 'Admin Panel';

  const setDocTitle = (newTitle: string) => {
    document.title = newTitle
      ? `Buddy Bot | ${DOMPurify.sanitize(newTitle, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })}`
      : defaultTitle;
  };

  useEffect(() => {
    switch (location.pathname) {
      case taskRoutes.create:
        setDocTitle('Create task');
        break;
      case taskManagementRoutes.taskGroups:
        setDocTitle('Task management - Task groups');
        break;
      case recognitionRoutes.create:
        setDocTitle('Task management - Create recognition');
        break;
      case location.pathname.includes(recognitionRoutes.base) &&
        location.pathname:
        setDocTitle('Task management - Recognition');
        break;
      case location.pathname.includes(taskRoutes.base) && location.pathname:
        setDocTitle('Task management');
        break;
      case '/permissions':
        setDocTitle('Admin management');
        break;
      case '/statistics':
        setDocTitle('Statistics');
        break;
      case settingsRoutes.base:
        setDocTitle('Settings');
        break;
      case settingsRoutes.admins:
        setDocTitle('Settings - Admin management');
        break;
      case settingsRoutes.users:
        setDocTitle('Settings - User management');
        break;
      case settingsRoutes.versions:
        setDocTitle('Settings - Versions');
        break;
      case location.pathname.includes(settingsRoutes.application) &&
        location.pathname:
        setDocTitle('Settings - Application');
        break;
      case '/login':
        setDocTitle('Login');
        break;
      case '/forbidden':
        setDocTitle('No access');
        break;
      case broadcastRoutes.create:
        setDocTitle('Create broadcast');
        break;
      case location.pathname.includes(broadcastRoutes.base) &&
        location.pathname:
        setDocTitle('Broadcasts');
        break;
      case '/home':
        setDocTitle('Home');
        break;
      default:
        setDocTitle('Not found');
    }
  }, [location.pathname]);
};
